import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAddress } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SearchAddressPayload } from 'src/app/interfaces/address/address.interface';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { AddressService } from './address.service';

@Injectable({
    providedIn: 'root',
})
export class AddressServiceImpl implements AddressService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    getAddressParams(address: SearchAddressPayload): Observable<IAddress[]> {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) => {
                let reqUrl = `${env.baseUrl}/address?streetAddress=${address.streetAddress}&city=${address.city}&postCode=${address.postalCode}`;
                if (address?.unit) {
                    reqUrl += `&unit=${address.unit}`;
                }
                return this.http.get(reqUrl) as Observable<IAddress[]>;
            }),
        );
    }

    getAddressQuery(query: string): Observable<IAddress[]> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.get(`${env.baseUrl}/cerberus/address/search?query=${encodeURI(query)}`) as Observable<IAddress[]>));
    }
}

export const ADDRESS_SERVICE_PROVIDER_IMPL = {
    provide: AddressService,
    useClass: AddressServiceImpl,
};
